<template>
  <section>
    <section v-if="errored">
      <p>{{ errorlist }}</p>
    </section>

    <section v-else>
      <spinner-loader-icon v-if="loading" />

      <div v-else>
        <h2 class="h2 h2float">Content Index</h2>
        <table class="lfloat">
          <tbody>
            <tr>
              <td>
                <v-text-field
v-model="search" style="width: 300px" label="Search content by Symbol ID or Name"
                  variant="outlined"></v-text-field>
              </td>
              <td>
                <span id="basic-addon2" class="input-group-text">
                  <font-awesome-icon icon="search" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <br /><br />
        <v-data-table id="contentTable" :headers="fields" :items="filteredList" show-sort-icon class="contentTable">
          <!-- NAS_ID header with tooltip -->
          <template #header.NAS_ID="{ column, toggleSort, isSorted, sortBy }">
            <div class="align-center" style="cursor: pointer;" @click="toggleSort">
              <span class="tight-header mr-1">NAS ID</span>
              <v-tooltip max-width="500" location="bottom">
                <template #activator="{ props }">
                  <span v-bind="props">
                    <font-awesome-icon icon="question-circle" class="question" size="sm" />
                  </span>
                </template>
                <span>{{ nasIdTip }}</span>
              </v-tooltip>
              <v-icon v-if="isSorted(column)" size="30" class="ml-1">
                {{sortBy.some(s => s.key === column.key && s.order === 'desc') ? 'mdi-arrow-down' : 'mdi-arrow-up'}}
              </v-icon>
            </div>
          </template>

          <!-- GeometryExtracted header with tooltip -->
          <template #header.GeometryExtracted="{ column, toggleSort, isSorted, sortBy }">
            <div class="align-center" style="cursor: pointer;" @click="toggleSort">
              <span class="tight-header">Geometry Extracted </span>
              <v-tooltip max-width="500" location="bottom">
                <template #activator="{ props }">
                  <span v-bind="props"> <font-awesome-icon icon='question-circle' class='question' size='sm' /> </span>
                </template>
                <span>{{ geoExtractedTip }}</span>
              </v-tooltip>
              <v-icon v-if="isSorted(column)" size="30" class="ml-1">
                {{sortBy.some(s => s.key === column.key && s.order === 'desc') ? 'mdi-arrow-down' : 'mdi-arrow-up'}}
              </v-icon>
            </div>
          </template>

          <!-- NAS_ID cell with external link -->
          <template #item.NAS_ID="{ item }">
            <a :href="`https://nsgreg.nga.mil/as/view?i=${item.NAS_ID}`" target="_blank">
              {{ item.NAS_ID }}
            </a>
          </template>

          <!-- Name cell with router-link -->
          <template #item.Name="{ item }">
            <router-link :to="{ name: 'datadetail', params: { NAS_ID: item.NAS_ID } }" :title="item.Definition">
              {{ item.Name }}
            </router-link>
          </template>
        </v-data-table>

        <!-- </b-container> -->
      </div>
    </section>
  </section>
</template>
<script>
import apiService from '@/apiService.js';
import state from '@/state.js';

export default {
  /* name optional but recommended for debugging */
  name: 'DataTable',
  data: function () {
    return {
      search: '',
      nasID: null,
      loading: true,
      errored: false,
      errorlist: '',
      //call the global state for this data property
      geoExtractedTip: state.geoExtractedTip,
      nasIdTip: state.nasIdTip,
      sortDes: false,
      fields: [
        {
          title: 'NAS ID',
          key: 'NAS_ID',
          sortable: 'true',
          headerClass: 'tight-header',
        },
        { title: 'Name', key: 'Name', sortable: 'true', headerClass: 'tight-header' },
        { key: 'GeometryExtracted', sortable: 'true', headerClass: 'tight-header' },
      ],
    };
  },
  computed: {
    filteredList() {
      return this.nasID.filter((item) => {
        const itemName = item.Name.toLowerCase();
        // const itemDefinition = item.Definition.toLowerCase();
        const itemId = item.NAS_ID.toString();
        const search = this.search.toLowerCase();

        return (
          itemName.includes(search) || itemId.includes(search)
          // itemDefinition.includes(search)
        );
      });
    },
  },
  created: function () {
    // fetch the data when the view is created and the data is
    // already being observed
    apiService
      .getDefinitions()
      .catch((error) => {
        console.log(error);
        this.errored = true;
        this.errorlist = error;
      })
      .then((response) => {
        this.loading = false;
        this.nasID = response.data;
      });
  },
};
</script>

<style scoped>
.contentTable th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

a.page-link {
  color: #32a6ad;
}

.page-item.active .page-link {
  background-color: #32a6ad !important;
  border-color: #32a6ad !important;
}

.lfloat {
  float: right;
}

.h2float {
  float: left;
}
.tight-header{
  font-weight: 600;
  font-size: 1.3em;}
</style>
